<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Kørende partner</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <div>
    <form [formGroup]="form" autocomplete="off">
      <div class="form-row">
        <app-partner-active-input [form]="form" [partners]="activePartners"></app-partner-active-input>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" color="primary">
          <mat-label>Skift træder i kraft</mat-label>
          <input #input matInput [matDatepicker]="picker" formControlName="validFrom" [min]="tomorrow" />
          <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-hint>
            dd+n eller dd-n kan bruges i dette felt.
            <br />
            F.eks. dd+14 vil give en dato som er 14 dage fra dags dato.
          </mat-hint>
        </mat-form-field>
      </div>
    </form>
  </div>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Gem</button>
  <button (click)="cancel()" class="modal-cancel" mat-raised-button>Fortryd</button>
</div>
